import Vue from 'vue'
import Vuex from 'vuex'

// import state from './state'
// import mutations from './mutations'
// import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    article: {},
    filter: ""
  },
  mutations: {
    setFilter(state, value) {
      state.filter = value
    }
  },
  getters: {
    getFilter(state) {
      return state.filter
    }
  }
})
